import { Money } from './money.model'
import { Address } from './address.model'

export class OrderDTO {
	customerUUID: string
	shippingAddress: Address
	billingAddress:	Address
	shoppingCartId: string
	paymentType: string
	shipmentType: string
	shipmentFee: Money
	ticketAddresses: Record<string, Address>
	comment: string
}



// WEBPACK FOOTER //
// ./src/app/models/order-dto.model.ts